import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { SeasonsWidget } from './SeasonsWidget'

class HoldstyringSeasonsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return SeasonsWidget
  }

  // Supported HTML attributes:
  //   layout="cards|detailed"  — cards = summary grid (default);
  //                              detailed = single-column with per-class breakdown
  //                              (day, time, instructor, price, spots).
  //   hold-type-slugs="jagt,hund" — only courses where at least one class carries
  //                              one of these hold-mærkat slugs (same attribute
  //                              as the schedule widgets). The course is still
  //                              shown with all its classes.
  protected getWidgetProps() {
    const raw = this.getAttribute('layout')
    const layout: 'cards' | 'detailed' = raw === 'detailed' ? 'detailed' : 'cards'
    const slugsRaw = this.getAttribute('hold-type-slugs') || ''
    const holdTypeSlugs = slugsRaw.split(',').map(s => s.trim()).filter(Boolean)
    return { layout, holdTypeSlugs }
  }
}

if (!customElements.get('holdstyring-seasons')) {
  customElements.define('holdstyring-seasons', HoldstyringSeasonsElement)
}

export { HoldstyringSeasonsElement }
